<template>
  <div>
    <div class="columns is-mobile">
      <div class="column is-2 is-mobile">
        <img
          width="25"
          :src="$helpers.airlineLogo(leg.airlineCode, 100, 100)"
          class="mt-1"
        />
      </div>
      <div class="column is-10">
        <div class="columns is-mobile is-gapless" style="margin-bottom:8px">
          <div class="column is-narrow">
            <div class="has-text-weight-bold">
              {{ leg.from }}
            </div>
            <div class="is-size-7 has-text-grey">
              {{ getAirportLocation(leg.from) }}
            </div>
          </div>
          <div class="column is-narrow">
            <span class="is-size-7 mt-2 px-2 is-block">
              <b-icon icon="arrow-right" class="has-text-grey-light"></b-icon>
            </span>
          </div>
          <div class="column is-narrow">
            <div class="has-text-weight-bold">
              {{ leg.to }}
            </div>
            <div class="is-size-7 has-text-grey">
              {{ getAirportLocation(leg.to) }}
            </div>
          </div>
        </div>

        <span class="is-size-6 has-text-grey-light">{{
          leg.legs[0].departingAt.date | formatDate
        }}</span>
        <br />
        <div class="is-size-6">
          {{ leg.legs[0].departingAt.time | formatTime }} -
          {{ leg.legs.slice(-1).pop().arrivingAt.time | formatTime }}
        </div>
        <OutOfPolicyTag
          v-if="leg.travelPolicy"
          class=""
          :travelPolicy="leg.travelPolicy"
        ></OutOfPolicyTag>
        <a
          v-if="!display_full"
          @click="display_full = !display_full"
          class="gant-text is-size-7"
          >Show details</a
        >
        <a v-else @click="display_full = !display_full" class="is-size-7"
          >Hide details</a
        >
        <a
          v-if="route != '/pnr'"
          class="is-size-7 teal-text"
          style="padding-left: 20px;"
          @click="goToSeatMaps()"
        >
          {{ seatMessage }}
        </a>
      </div>
    </div>

    <div v-if="display_full" style="padding-top: 10px;">
      <FlightDetails :journeys="[leg]"></FlightDetails>
    </div>
  </div>
</template>

<script>
import SeatMapMenu from "../SeatMap/SeatMapMenu.vue";
import FlightDetails from "../BookTravel/Air/FlightDetails.vue";
import OutOfPolicyTag from "../Tags/OutOfPolicyTag.vue";

export default {
  name: "SmallFlightItinerary",
  props: {
    leg: Object,
    journeys: Array,
    guestIndex: Number,
  },
  components: {
    FlightDetails,
    OutOfPolicyTag,
  },
  data: function() {
    return {
      loading: true,
      display_full: false,
      mapResponse: null,
    };
  },
  computed: {
    route() {
      return this.$route.path;
    },
    seatMessage() {
      var message;
      if (this.leg.legs.length > 1) {
        message = "Select Seats ";
      } else {
        message = "Select Seat ";
      }
      var seats = [];
      var realSeat = false;
      for (var i = 0; i < this.leg.legs.length; i++) {
        //// console.log(this.leg.legs[i])
        if (this.leg.legs[i].selectedSeat) {
          seats.push(this.leg.legs[i].selectedSeat.id);
          realSeat = true;
        } else {
          seats.push("-");
        }
      }
      if (realSeat) {
        message = message + "(" + seats.join(", ") + ")";
      }
      return message;
    },
  },
  methods: {
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        ({ code }) => code == airportCode
      );
      if (!airport) return null;
      return airport.city + ", " + airport.state;
    },

    goToSeatMaps() {
      var details;
      details = {
        parent: this,
        component: SeatMapMenu,
        props: {
          activeTab: this.leg.segmentIndex - 1,
          flightProp: this.journeys,
          guestIndex: this.guestIndex,
        },
        hasModalCard: true,
        trapFocus: true,
      };

      this.$buefy.modal.open(details);
    },
    /*      
        availableSeats(num){
          if (num == '9') {
            return '9+'
          }
          return num
      },
      async getMap() {
          //var myHeaders = new Headers();
          //myHeaders.append("Content-Type", "application/json-responses");
          // console.log(this.leg)

          var raw = {
            "departureAirport": this.leg.departingAirport,
            "arrivalAirport": this.leg.arrivingAirport,
            "airlineCode": this.leg.marketingAirline.code,
            "flightNumber": this.leg.flightNumber,
            "departureDate": this.leg.departingAt.date
          };

          // console.log(raw)

          this.$app.huddleLabsServerCall('amadeus/air/seat-map', raw)
            .then(result => {
              if (result.flightDetails) {
                this.mapResponse= result
              }
            })
            .then(console.log(this.mapResponse))
            .then(this.loading = false)
        },

        */
  },
};
</script>

<style scoped></style>
